// imports here
import { authLocalStorage } from '../helpers/authentication'

// initial state
const state = {
  currentUser: authLocalStorage(),
  loggedIn: !!authLocalStorage(),
  loading: false,
  errors: null
}

// getters
const getters = {
  isLoggedIn: state => state.loggedIn,
  isLoading: state => state.loading,
  currentUser: state => state.currentUser,
  hasErrors: state => state.errors
}

// mutations
const mutations = {
  loginSuccess: (state, payload) => {
    state.currentUser = Object.assign({}, payload.user, { token: payload.access_token })
    localStorage.setItem('user', JSON.stringify(state.currentUser))
  },
  logoutSuccess: (state) => {
    localStorage.removeItem('user')
    state.loggedIn = false
    state.currentUser = null
  },
  updateToken: (state, payload) => {
    const updatedUser = Object.assign({}, state.currentUser, { token: payload })
    localStorage.setItem('user', JSON.stringify(updatedUser))
    state.currentUser = updatedUser
  },
  setLoading: (state, payload) => state.loading = payload,
  setErrors: (state, payload) => state.errors = payload
}

// actions
const actions = {
  login: ({ commit }, payload) => commit('loginSuccess', payload),
  logout: ({ commit }) => commit('logoutSuccess'),
  updateToken: ({ commit }, payload) => commit('updateToken', payload),
  setLoading: ({ commit }, payload) => commit('setLoading', payload),
  setErrors: ({ commit }, payload) => commit('setErrors', payload)
}

// export variables with namespaced
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
